import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { FaSpinner } from "react-icons/fa";

const Input = styled.input`
  display: block;
  width: 100%;
  margin-bottom: 25px;
  padding: 15px;
  border: 0;
  border-radius: 5px;
  border: 1px solid #dae1e7;
  /* background: hsl(100, 0%, 98%); */
  text-align: left;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08); */

  &.error {
    border: 1px solid hsl(1.7, 76.3%, 53.7%);
  }
`;

const ErrorMsg = styled.p`
  color: hsl(1.7, 76.3%, 53.7%);
  font-size: 12px;
  margin-bottom: 10px;
  margin-top: -20px;
`;

const Submit = styled.button`
  /* margin-top: 15px; */
  cursor: pointer;
  float: right;
  padding: 15px 20px;
  /* text-transform: uppercase; */
  font-weight: bold;
  line-height: 1.15;
  border: 0;
  border-radius: 5px;
  /* background: hsl(117, 34.2%, 54.1%); */
  background: hsl(201.1, 56.1%, 60.6%);
  color: hsl(117, 20%, 95%);
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08); */
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  width: 100%;

  :hover,
  :active {
    /* background: hsl(117, 34.2%, 44.1%); */
    background: hsl(201.1, 56.1%, 40.6%);
  }

  :disabled {
    background: hsl(201.1, 56.1%, 80.6%) !important;
    cursor: not-allowed;
  }
`;

const SystemName = styled.div`
  display: grid;
  border: 0;
  /* flex-wrap: nowrap; */
  /* justify-content: center; */
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr;
  min-inline-size: none;

  input {
    /* flex: 2; */
    border-right: 0;
    /* display: inline; */
  }

  .domain {
    /* flex: 1; */
    word-break: keep-all;
    padding: 15px;
    border: 1px solid #dae1e7;
    /* background: hsl(100, 0%, 98%); */
    /* box-shadow: 0 8px 12px -4px rgba(0, 0, 0, 0.12),
      0 4px 6px -2px rgba(0, 0, 0, 0.08); */
    margin-bottom: 25px;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    margin-left: -5px;
    z-index: 150;
    background: white;
    pointer-events: none;
    /* background: hsl(207.7, 21.3%, 95%); */
    background: hsl(201.2, 80%, 95%);
    color: hsl(201.2, 60%, 40%);
    display: block;
    white-space: nowrap;
  }

  .domain.error {
    border: 1px solid hsl(1.7, 76.3%, 53.7%);
    border-left: 0;
  }

  @media (max-width: 500px) {
    & {
      grid-template-columns: 1fr;
    }

    input {
      text-align: left;
      border-right: 1px solid #dae1e7;
    }

    .domain {
      display: none;
    }
  }
`;

const FormLogo = styled.img`
  display: block;
  margin: 0 auto;
  margin-bottom: 1.5rem;
  max-width: 100%;
`;

const FormHeader = styled.h3`
  margin-bottom: 1rem;
  text-align: center;
  color: #000000;

  @media (max-width: 500px) {
    & {
      font-size: 16px;
    }
  }
`;

const Spinner = styled.span`
  @keyframes fa-spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(359deg);
      transform: rotate(359deg);
    }
  }

  svg {
    animation: fa-spin 2s infinite linear;
    width: initial !important;
    height: initial !important;
    min-height: initial !important;
  }
`;

const DemoForm = ({
  url,
  header,
  type,
  checkIsSystemValid,
  handleFieldChange,
  systemValid,
  emailValid,
  passwordValid,
  logo,
  gaCookie,
  utmCookie,
  utmMediumCookie,
  submitDisabled,
  submitButtonText,
  systemNameValue,
  systemLoginValue,
  systemPasswordValue,
  systemType
}) => {
  const [submitting, setSubmitting] = useState(false);

  return (
    <form onSubmit={() => setSubmitting(true)} action={url} method="post">
      {logo && (
        <Link to="/">
          <FormLogo src={logo} alt="logo quickcrm" />
        </Link>
      )}
      <FormHeader>{header}</FormHeader>

      {type === "login" ? (
        <>
          <input
            type="hidden"
            name="try_login"
            id="try_login"
            value="try_login"
          />
          <input type="hidden" id="ga_value" name="ga_value" value={gaCookie} />
          <input
            type="hidden"
            id="utm_source"
            name="utm_source"
            value={utmCookie}
          />
          <input
            type="hidden"
            id="utm_medium"
            name="utm_medium"
            value={utmMediumCookie}
          />
        </>
      ) : (
        <>
          <input type="hidden" name="system-type" value={systemType} />
          <input type="hidden" id="ga_value" name="ga_value" value={gaCookie} />
          <input
            type="hidden"
            id="utm_source"
            name="utm_source"
            value={utmCookie}
          />
          <input
            type="hidden"
            id="utm_medium"
            name="utm_medium"
            value={utmMediumCookie}
          />
        </>
      )}

      <SystemName>
        <Input
          placeholder="Nazwa systemu"
          required
          type="text"
          onChange={e => handleFieldChange(e)}
          value={systemNameValue}
          name={type === "login" ? "systemName" : "system-name"}
          // className={!systemValid ? "error" : ""}
          onKeyUp={e => checkIsSystemValid(e)}
        />
        <span className={`domain`}>.questy-cloud.pl</span>
      </SystemName>
      {/* {!systemValid && (
        <ErrorMsg>System o takiej nazwie nie istnieje</ErrorMsg>
      )} */}
      {type === "login" && !systemValid ? (
        <ErrorMsg>System o takiej nazwie nie istnieje</ErrorMsg>
      ) : null}
      {type === "create" && systemValid && systemNameValue !== "" ? (
        <ErrorMsg>System o podanej nazwie już istnieje</ErrorMsg>
      ) : null}
      <Input
        placeholder="E-mail"
        required
        type="email"
        onChange={e => handleFieldChange(e)}
        value={systemLoginValue}
        name={type === "login" ? "security_username" : "system-email"}
        id={type === "login" ? "security_username" : "system-email"}
      />
      {type === "create" && !emailValid ? (
        <ErrorMsg>Adres jest niepoprawny</ErrorMsg>
      ) : null}
      <Input
        placeholder="Hasło"
        required
        type="password"
        onChange={e => handleFieldChange(e)}
        value={systemPasswordValue}
        name={type === "login" ? "security_password" : "system-password"}
        id={type === "login" ? "security_password" : "system-password"}
      />
      {type === "create" && !passwordValid ? (
        <ErrorMsg>Hasło powinno mieć min. 8 znaków</ErrorMsg>
      ) : null}
      <Submit
        disabled={
          (type === "login"
            ? !systemValid
            : submitDisabled && systemNameValue !== "") || submitting
        }
        type="submit"
      >
        {submitting ? (
          <span>
            {submitButtonText}
            {` `}
            <Spinner>
              <FaSpinner />
            </Spinner>
          </span>
        ) : (
          submitButtonText
        )}
      </Submit>
    </form>
  );
};

export default DemoForm;
